import "katex/dist/katex.min.css";

import Latex from "react-latex-next";
import type { FC } from "react";
import { Form } from "react-bootstrap";

import Layout from "./_Layout";
import SelfEvaluationTask from "features/SelfEvaluation/Practice/Task";

import type { UserAssignmentDetailFragment } from "api/generated";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { selectSimpleAnswer, setSimpleAnswer } from "store/slices/answer";

import { AssignmentPrompt } from "components/AssignmentPrompt";

/* cgRyAE4Kk1Ol2MGnphOA */

interface Props {
  data: UserAssignmentDetailFragment;
  onSubmit: () => void;
}

const JednoslovneOdpovedi: FC<Props> = ({ data, onSubmit }) => {
  const questionsCount = data.assignment?.assignment?.questions.length ?? 0;
  const isSelfEvaluation = data.assignment?.scoring?.scoringMethod?.scoringMethod === "sebeopravení";

  const selected = useAppSelector(selectSimpleAnswer);
  const dispatch = useAppDispatch();

  const handleChange = (index: number, value: string) => {
    const newAnswers =
      !Array.isArray(selected) || selected.length === 0 ? new Array<string>(questionsCount).fill("") : [...selected];
    newAnswers[index] = value;

    dispatch(setSimpleAnswer(newAnswers));
  };

  const areAnswersFilled = () => {
    if (!Array.isArray(selected)) {
      console.error(`Unknow data type: `, selected, typeof selected);
      return false;
    }

    return selected.length > 0 && selected.every(answer => answer.length > 0);
  };

  if (isSelfEvaluation) {
    return <SelfEvaluationTask userAssignment={data} onSubmit={onSubmit} />;
  }

  return (
    <Layout onSubmit={onSubmit} isSubmitDisabled={!areAnswersFilled()}>
      <div>
        <AssignmentPrompt assignment={data.assignment?.assignment} />

        {data.assignment?.assignment?.questions.map((question, qIndex) => (
          <div key={question.heading} className="mt-20px question">
            <Latex>{question.heading ?? ""}</Latex>

            <Form.Control
              onChange={event => {
                handleChange(qIndex, event.target.value);
              }}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
            ></Form.Control>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default JednoslovneOdpovedi;
